import { BRANDING_MAP } from '@/constants/brandingMap'
import type { Order } from '@/types/commerce'

export function hasBrandingConfig(appCode: string): boolean {
  return (BRANDING_MAP[appCode]?.length ?? 0) > 0
}

export function resolveBrandingTag(orders: Order[], appCode: string): string | null {
  const entries = BRANDING_MAP[appCode] ?? []
  for (const entry of entries) {
    const matches = orders.some(order => {
      const productMatches = order.product?._id === entry.productId
      if (!entry.statuses?.length) return productMatches
      return productMatches && entry.statuses.includes(order.status)
    })
    if (matches) return entry.cinematicsTag
  }
  return null
}
